<template>
  <div class="rs-container">
    <div class="rs-wrapper">
      <div class="re-title-view">
        <div class="rs-title">推荐商家</div>
      </div>
      <div class="break-line"/>
      <div class="whatever">
        <div class="title-input">
          <span class="title-view">
            <span class="title">商家名称</span>
            <span class="star"><img src="../../../static/img/user/xh.png"></span>
          </span>
          <input v-model="name" class="input" @keydown.enter="recommendShop" autofocus placeholder="请输入商家名称">
        </div>
        <div class="title-input">
          <span class="title-view">
            <span class="title">商家电话</span>
            <span class="star"><img src="../../../static/img/user/xh.png"></span>
          </span>
          <input v-model="tel" @keydown.enter="recommendShop" class="input" placeholder="请输入商家电话">
        </div>
        <div class="title-input">
          <span class="title-view">
            <span class="title">商家微信</span>
            <span class="star"/>
          </span>
          <input v-model="wx" @keydown.enter="recommendShop" class="input" placeholder="请输入商家微信">
        </div>
        <div class="title-input">
          <span class="title-view">
            <span class="title">商家QQ</span>
            <span class="star"/>
          </span>
          <input v-model="qq" @keydown.enter="recommendShop" class="input" placeholder="请输入商家QQ">
        </div>
        <div class="title-input">
          <span class="title-view">
            <span class="title">商家地址</span>
            <span class="star"/>
          </span>
          <input v-model="address" @keydown.enter="recommendShop" class="input" placeholder="请输入商家地址">
        </div>
        <div class="upload-picture">
          <span class="title">商家图片</span>
          <div
            v-for="(item, index) in pic_list_arr"
            :key="index"
            class="pic-list">
            <img :src="item" class="upload-pic">
            <img @click="picRemove(index)" class="delete-icon" src="../../../static/img/user/delete.png">
          </div>
          <label>
            <img class="upload-view" src="../../../static/img/user/upload_pic.png">
            <input class="upload-file" type="file" multiple @change="selectImgs($event)" ref="file">
          </label>
        </div>
        <div class="title-input">
          <span class="title-view">
            <span class="title">推荐原因</span>
            <span class="star"><img src="../../../static/img/user/xh.png"></span>
          </span>
          <input v-model="reason" @keydown.enter="recommendShop" class="input" placeholder="请输入您推荐该店的原因">
        </div>
        <div class="submit-view"><div @click="recommendShop" class="submit">确认推荐</div></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RecommendedShop',
  data () {
    return {
      name: '',
      tel: '',
      wx: '',
      qq: '',
      address: '',
      pic_list_arr: [],
      file_arr: [],
      reason: ''
    }
  },
  methods: {
    /**
     * 提交推荐
     */
    recommendShop () {
      if (this.name === '' || this.tel === '' || this.reason === '') {
        this.$store.commit('show_alert', '必填项不能为空')
        return
      }
      var formData  = new FormData();
      formData.append('busi_name', this.name);
      formData.append('tel', this.tel);
      formData.append('reason', this.reason);
      formData.append('user_id', this.$store.state.user_info.id);
      formData.append('wechat', this.wx);
      formData.append('qq', this.qq);
      formData.append('busi_address', this.address);
      if (this.file_arr) {
        this.file_arr.forEach((item, i) => {
          formData.append('upload_files', item);
        })
      }
      // 请求数据
      this.APIS.RECOMMEND_SHOP(formData)
      .then((res) => {
        switch (res.data.status) {
          case 0:
            // 清空数据
            this.name = ''
            this.qq = ''
            this.tel = ''
            this.wx = ''
            this.address = ''
            this.reason = ''
            this.pic_list_arr = []
            this.file_arr = []
            this.$store.commit('show_alert', '推荐成功')
            break
          case 2:
            this.$store.commit('show_alert', '不要重复推荐同一家商家')
            break
          default:
            this.$store.commit('show_alert', '推荐失败')
        }
      })
      .catch((err) => {
        this.$store.commit('show_alert', '推荐失败')
      })
    },
    /**
     * 选择图片
     */
    selectImgs (e) {
      var file = this.$refs.file.files[0]
      let supportedTypes = ['image/jpg', 'image/jpeg', 'image/png'];
      if (file.size <= 102400 * 5) {
        if (file && supportedTypes.indexOf(file.type) >= 0) {
          e.preventDefault();
          var _this = this
          var reader = null
          reader = new window.FileReader()
          reader.readAsDataURL(file)
          reader.onload = function (e) {
            _this.pic_list_arr.push(e.target.result)
          }
          _this.file_arr.push(file)
        } else {
          this.$store.commit('show_alert', '图片格式只支持：jpg、jpeg 和 png哦')
        }
      } else {
        this.$store.commit('show_alert', '上传的图片不能超过500KB哦!')
      }
    },
    /**
     * 移除图片
     */
    picRemove (i) {
      this.pic_list_arr.splice(i, 1);
      this.file_arr.splice(i, 1);
    },
  }
}
</script>

<style lang="less" scoped>
::-webkit-input-placeholder {
  color: #cccccc;
}
.rs-container {
  width: calc(~"100% - 16px");
  display: flex;
  justify-content: center;
  .rs-wrapper {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    .re-title-view {
      width: 900px;
      .rs-title {
        font-size: 20px;
        color: #333333;
        margin-top: 30px;
      }
    }
    .break-line {
      width: 900px;
      margin-top: 20px;
      border-bottom: 1px solid #e0e0e0;
    }
    .whatever {
      width: 100%;
      height: calc(~"100% - 75px");
      overflow: auto;
      .title-input {
        width: 900px;
        height: 100px;
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-left: 22px;
        border-bottom: 1px solid #e0e0e0;
        .title-view {
          display: flex;
          align-items: center;
          width: 100px;
          .title {
            width: 100px;
            font-size: 18px;
            color: #333333;
          }
          .star {
            width: 26px;
            height: 30px;
            display: flex;
            align-items: center;
            margin-left: 5px;
            font-size: 18px;
            color: #ff4c4c;
            border-right: 1px solid #e0e0e0;
          }
        }
        .input {
          height: 20px;
          font-size: 18px;
          margin-left: 30px;
          padding-left: 2px;
          outline: none;
          border: 0;
          background-color: #ffffff;
        }
      }
      .upload-picture {
        width: 900px;
        height: 180px;
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-left: 22px;
        border-bottom: 1px solid #e0e0e0;
        .title {
          width: 100px;
          color: #333333;
          font-size: 18px;
          margin-bottom: 80px;
        }
        .pic-list {
          width: 100px;
          height: 100px;
          display: flex;
          flex-direction: row;
          margin-right: 10px;
          .upload-pic {
            width: 100px;
            height: 100px;
          }
          .delete-icon {
            width: 24px;
            height: 24px;
            margin-left: -12px;
            margin-top: -12px;
            cursor: pointer;
          }
        }
        .upload-view {
          width: 100px;
          height: 100px;
          margin-left: 30px;
          cursor: pointer;
        }
        .upload-file {
          display: none;
        }
      }
      .submit-view {
        width: 100%;
        display: flex;
        justify-content: center;
        .submit {
          width: 240px;
          height: 54px;
          display: flex;
          align-self: center;
          justify-content: center;
          align-items: center;
          background-color: #ff9a28;
          border-radius: 27px;
          font-size: 18px;
          color: #ffffff;
          margin-top: 50px;
          margin-bottom: 50px;
          cursor: pointer;
        }
        .submit:hover {
          background-color: #f08710;
        }
      }
      .tips {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        position: absolute;
        background-color: #000000;
        border-radius: 30px;
        opacity: 0.5;
        margin-top: 10px;
        padding: 20px 60px;
        .img {
          width: 30px;
          height: 30px;
        }
        .msg {
          display: inline-block;
          font-size: 18px;
          color: #fefefe;
          margin-left: 10px;
        }
      }
      .tips {
        position: absolute;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/user/recommended_shop.vue